import React from "react"
import { Skeleton } from "@quorumus/plum"
import { SkeletonStack } from "QuorumGrassroots/campaign-forms/components/GotvV2Form/components/LoadingSkeleton/LoadingSkeleton.styles"

export const LoadingSkeleton = () => {
    return (
        <SkeletonStack>
            <Skeleton height={32} width="50%" radius="sm" animate />
            <Skeleton height={83} width="100%" radius="sm" animate />
            <Skeleton height={32} width="100%" radius="sm" animate />
            <Skeleton height={32} width="100%" radius="sm" animate />
            <Skeleton height={32} width="100%" radius="sm" animate />
            <Skeleton height={32} width="100%" radius="sm" animate />
            <Skeleton height={32} width="100%" radius="sm" animate />
            <Skeleton height={32} width="30%" radius="sm" animate />
        </SkeletonStack>
    )
}
